module.exports = __webpack_public_path__ + "f80a3e9fb211771e98bcf0fff259f0cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/App/assets/AppDownload.png
// module id = 2001
// module chunks = 1